<template>
  <div class="mb-container flexbox-column">
    <div class="header-container">
      <div class="content-title-mb">
        <div class="title-head-mb">
          <div class="title-cn-mb">客户资产与消费&amp;还款分析报告</div>
          <div class="custom-title-mb">公司：{{ dataMap.custom.name }}&nbsp;&nbsp;&nbsp;&nbsp;数据来源：<span
            v-for="(bank, i) in homeStat.billTypeList" :key="`bank-${i}`">  {{ bank }} &nbsp;</span>
            <br>账单周期：{{ homeStat.startTime }} 到{{ homeStat.endTime }}&nbsp;合计：{{ homeStat.statMonth }}个月
          </div>
        </div>
      </div>
      <div style="display: flex;">
        <Menu mode="horizontal" :theme="theme1" accordion="true" :active-name="activeData" @on-select="menuSelect"  ref="dataMenu" >
          <MenuItem name="checkResult">
            <Icon type="ios-paper"/>
            数据报告
          </MenuItem>
          <MenuItem name="dataReport">
            <Icon type="ios-people"/>
            汇总报表
          </MenuItem>
        </Menu>
        <div  style="width: 33%;">
          <Select ref="detailSelect" style="width: 100%;margin-top: 15px;" placeholder="详细信息" @on-select="detailSelected" clearable="true">
            <Option value="3-0">资产与收入</Option>
            <Option value="3-1">分渠道收支汇总</Option>
            <Option value="3-2">负面相关</Option>
            <Option value="3-3">消费信贷</Option>
            <Option value="3-4">理财数据</Option>
            <Option value="3-5">生活交易</Option>
            <Option value="3-6">转账交易</Option>
            <Option value="3-7">交易数据</Option>
            <Option value="3-8">公司信息</Option>
          </Select>
        </div>
      </div>
    </div>
    <div class="section-box flex-1">
      <div class="section-box-content">
        <ContentTitleV4 v-if="showContentBoardCheckV4" ref="contentTitle" :data-map="dataMap" :home-stat="homeStat"
                        :score="score"></ContentTitleV4>
        <ContentBoardV4 v-if="showContentBoardCheckV4" ref="contentBoard" :data-map="dataMap" :home-stat="homeStat"
                        :score="score"
                        :boardData="boardData"></ContentBoardV4>
        <ContentBoardCheckV4 v-if="showContentBoardCheckV4" ref="ContentBoardCheckV4" :data-map="dataMap"
                             :home-stat="homeStat" :score="score" :boardData="boardData"></ContentBoardCheckV4>
        <ContentDataReportV4 v-if="showContentDataReportV4" ref="contentDataReport" :home-sta="homeStat" :stat="stat"
                             :bar-data="barData"
                             :score="score" :data-map="dataMap"></ContentDataReportV4>
        <ContentDetailV4 v-if="showContentDetailV4" ref="contentDetail" :home-sta="homeStat"
                         :stat="stat" :bar-data="barData" :score="score" :data-map="dataMap"
                         :tab-name="tabName"></ContentDetailV4>
      </div>
    </div>
  </div>
</template>
<script>
import ContentTitleV4 from './content-title.vue'
import ContentBoardV4 from './content-board.vue'
import ContentBoardCheckV4 from './content-board-check.vue'
import ContentDetailV4 from './content-detail.vue'
import ContentDataReportV4 from './content-data-report.vue'
import html2canvas from 'html2canvas'
import printJS from 'print-js'
export default {
  props: {
    dataMap: Object,
    homeStat: Object,
    score: Object,
    boardData: Object,
    stat: Object,
    barData: Object
  },
  components: {
    html2canvas,
    printJS,
    ContentTitleV4,
    ContentBoardV4,
    ContentBoardCheckV4,
    ContentDetailV4,
    ContentDataReportV4
  },
  data () {
    return {
      theme1: 'light',
      showContentBoardCheckV4: true,
      showContentDataReportV4: false,
      showContentDetailV4: false,
      tabName: '3-0',
      activeData: 'checkResult',
      detailSelectData: ''
    }
  },
  methods: {
    detailSelected (data) {
      this.menuSelect(data.value)
    },
    menuSelect (menuName) {
      this.showContentBoardCheckV4 = false
      this.showContentDataReportV4 = false
      this.showContentDetailV4 = false
      switch (menuName) {
        case 'checkResult':
          this.$refs.detailSelect.clearSingleSelect()
          this.showContentBoardCheckV4 = true
          break
        case 'dataReport':
          this.$refs.detailSelect.clearSingleSelect()
          this.showContentDataReportV4 = true
          break
        case '3-0':
        case '3-1':
        case '3-2':
        case '3-3':
        case '3-4':
        case '3-5':
        case '3-6':
        case '3-7':
        case '3-8':
          this.showContentDetailV4 = true
          this.tabName = menuName
          this.activeData = 'checkResult'
          this.$nextTick(function () {
            this.$refs.dataMenu.updateActiveName()
          })
          break
      }
    }
  }
}
</script>
<style>
.mb-container {
  height: 100%;
  //display: flex;

  .section-box {
    //flex: 1;
    margin-top: 200px;
    overflow-y: scroll;
  }

  .header-container {
    top: 0;
    z-index: 100;
    position: fixed;
    width: 100%;
    background: #fff;
  }
}

.content-title-mb {
  background: #f5f7f9;
  position: relative;
  color: white;
  height: 132px;
  overflow: visible;
}

.title-head-mb {
  background-image: url(../../../../assets/images/content-v4/title/head-bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  padding: 0pt;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.title-cn-mb {
  font-family: YouSheBiaoTiHei;
  font-size: 20pt;
  margin-left: 10pt;
  margin-top: 30px;
  color: #1242CD;
}

.custom-title-mb {
  font-family: Microsoft YaHei;
  font-size: 10pt;
  color: #333333;
  margin-left: 4%;
  margin-top: 2%;
}
</style>
